import {
  MOON_500,
  MOON_650,
  MOON_800,
  THEME,
} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
Container.displayName = 'S.Container';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  flex: 1;
  overflow-y: auto;
`;
Content.displayName = 'S.Content';

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  letter-spacing: 0px;
`;
Title.displayName = 'S.Title';

export const Description = styled.div`
  font-size: 15px;
  font-weight: 400;
  font-family: 'Source Sans Pro';
  line-height: 140%;
  letter-spacing: 0px;
  color: light-dark(${MOON_650}, ${THEME.textSecondary});
`;
Description.displayName = 'S.Description';

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
SelectContainer.displayName = 'S.SelectContainer';

export const SelectLabel = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  font-family: 'Source Sans Pro';
  letter-spacing: 0px;
`;
SelectLabel.displayName = 'S.SelectLabel';

export const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  background: ${THEME.bgSurface};
`;
StickyFooter.displayName = 'S.StickyFooter';

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 20px 24px;
`;
ButtonContainer.displayName = 'S.ButtonContainer';

export const ButtonItem = styled.div`
  width: 100%;
`;
ButtonItem.displayName = 'S.ButtonItem';

export const OptionLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
OptionLabel.displayName = 'S.OptionLabel';

export const OptionaLabelText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: light-dark(${MOON_800}, ${THEME.textPrimary});
`;
OptionaLabelText.displayName = 'S.OptionaLabelText';

export const OptionLabelSubtitleText = styled.div`
  font-size: 14px;
  color: light-dark(${MOON_500}, ${THEME.textTertiary});
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
OptionLabelSubtitleText.displayName = 'S.OptionLabelSubtitleText';

export const OptionLabelTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
OptionLabelTextContainer.displayName = 'S.OptionLabelTextContainer';

export const OptionColorIndicator = styled.div`
  margin-top: 4px;
`;
OptionColorIndicator.displayName = 'S.OptionColorIndicator';

export const OptionRow = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
`;
OptionRow.displayName = 'S.OptionRow';

export const NoRunsMessage = styled.div`
  font-size: 15px;
  font-weight: 400;
  font-family: 'Source Sans Pro';
  line-height: 140%;
  letter-spacing: 0px;
  color: light-dark(${MOON_650}, ${THEME.textSecondary});
`;
NoRunsMessage.displayName = 'S.NoRunsMessage';

export const ConfigPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
ConfigPreviewContainer.displayName = 'S.ConfigPreviewContainer';

export const ConfigPreviewWrapper = styled.div`
  min-height: 150px;
  .MuiDataGrid-root {
    border: 1px solid light-dark(#e9ecef, ${THEME.border});
    border-radius: 6px;
  }
`;
ConfigPreviewWrapper.displayName = 'S.ConfigPreviewWrapper';
